import "./coupon-code.pcss";

document.addEventListener("click", event => {
    const toggleButton = event.target.closest(".coupon-code__toggle");
    if (toggleButton) {
        const block = toggleButton.closest(".coupon-code");
        block.classList.toggle("coupon-code--opened");
    }
});
